<template>
  <a-modal
    :title="title"
    :width="modalWidth"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="账号">
          {{username}}
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="用户姓名">
          <a-input type="text" placeholder="用户姓名" v-decorator="[ 'realname', validatorRules.realname]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="用户手机">
          <a-input type="text" placeholder="用户手机" v-decorator="[ 'phone', validatorRules.phone]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="用户邮箱">
          <a-input type="text" placeholder="用户邮箱" v-decorator="[ 'email', validatorRules.email]"/>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import Vue from 'vue'
  import store from '@/store/'
  import pick from 'lodash.pick'
  import moment from 'moment'
  import { putAction } from '@/api/manage'
  import { mapGetters } from 'vuex'
  import {duplicateCheck } from '@/api/api'
  import { USER_INFO} from "@/store/mutation-types"

  const user = {
    state: {
      token: '',
      username: '',
      realname: '',
      tenantid: '',
      welcome: '',
      avatar: '',
      permissionList: [],
      info: {},
      departInfo: []
    },

    mutations: {
      SET_TOKEN: (state, token) => {
        state.token = token
      },
      SET_NAME: (state, { username, realname, welcome }) => {
        state.username = username
        state.realname = realname
        state.welcome = welcome
      },
      SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
      },
      SET_PERMISSIONLIST: (state, permissionList) => {
        state.permissionList = permissionList
      },
      SET_INFO: (state, info) => {
        state.info = info
      },
      SET_DEPART_INFO: (state, info) => {
        state.departInfo = info
      },
      SET_TENANT: (state, id) => {
        state.tenantid = id
      },
    },
  }

  export default {

    name: "UserInfo",
    data () {
      return {
        title:"修改用户信息",
        modalWidth:800,
        visible: false,
        confirmLoading: false,
        validatorRules:{
          realname:{rules: [{ required: true, message: '请输入用户名称!' }]},
          phone:{
            rules: [{
              required: true,
              validator: this.validatePhone
            }]},
          email:{
            rules: [{
              required: true,
              validator: this.validateEmail
            }],
          }
        },
        confirmDirty:false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        form:this.$form.createForm(this),
        url: "sys/user/updateUserInfo",
        username:"",
      }
    },
    methods: {
      ...mapGetters(["userInfo"]),
      show(uname){
        if(!uname){
          this.$message.warning("当前系统无登录用户!");
          return
        }else{
          this.username = uname;
          console.log("userInfo",this.userInfo())
          this.$nextTick(() => {
            this.form.setFieldsValue(pick(this.userInfo(),'realname','email','phone'))
          });
          this.visible = true;
        }
      },
      handleCancel () {
        this.close()
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.disableSubmit = false;
        this.selectedRole = [];
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let params = Object.assign({username:this.username},values)
            putAction(this.url,params).then((res)=>{
              if(res.success){
                that.$message.success(res.result);
                const userInfo = this.userInfo()
                userInfo.realname = params.realname;
                userInfo.phone = params.phone;
                userInfo.email = params.email;

                Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
                store.commit('SET_INFO', userInfo)

                that.close();
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
      handleConfirmBlur  (e) {
        const value = e.target.value
        this.confirmDirty = this.confirmDirty || !!value
      },

      //!*校验手机号码*!/
      validatePhone(rule, value, callback){
        if (value.length == 0) {
          callback(new Error("请输入手机号码!"))
        }
          //update-begin--Author:kangxiaolin  Date:20190826 for：[05] 手机号不支持199号码段--------------------
          if(new RegExp(/^1[3|4|5|7|8|9][0-9]\d{8}$/).test(value)){
            //update-end--Author:kangxiaolin  Date:20190826 for：[05] 手机号不支持199号码段--------------------
            var params = {
              tableName: 'sys_user',
              fieldName: 'phone',
              fieldVal: value,
              dataId: this.userInfo().id
            };
            duplicateCheck(params).then((res) => {
              if (res.success) {
                callback()
              } else {
                callback(new Error("手机号已存在!"))
              }
            })
          }else{
            callback(new Error("请输入正确格式的手机号码!"));
          }
      },
      //!*校验邮箱地址*!/
      validateEmail(rule, value, callback){
        if (value.length == 0) {
          callback(new Error("请输入邮箱地址!"));
        }
          if(new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(value)){
            var params = {
              tableName: 'sys_user',
              fieldName: 'email',
              fieldVal: value,
              dataId: this.userInfo().id
            };
            duplicateCheck(params).then((res) => {
              console.log(res)
              if (res.success) {
                callback()
              } else {
                callback(new Error("邮箱已存在!"))
              }
            })
          }else{
            callback(new Error("请输入正确格式的邮箱!"))
          }
        }
    }
  }
</script>

<style scoped>

</style>

